<template>
  <b-modal v-model="inputVal.modal"
           centered
           hide-header
           hide-footer
           @hidden="handleModalHidden"
  >
    <div class="success-modal__body d-flex flex-column align-items-center">
      <span class="success-modal__msg mb-4">{{ inputVal.msg }}</span>
      <b-button v-if="inputVal.action === 'REMOVE'"
                variant="primary"
                size="large"
                @click="$router.replace(inputVal.back.location)"
      >
        {{ inputVal.back.text }}
      </b-button>
      <b-button v-else
                variant="primary"
                @click="inputVal.modal = false"
      >
        確定
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import { BButton } from 'bootstrap-vue';
import vModelMixin from '@/mixins/v-model';

export default {
  mixins: [vModelMixin],
  components: {
    BButton,
  },
  methods: {
    handleModalHidden() {
      if (this.inputVal.action === 'REMOVE') {
        this.$router.replace(this.inputVal.back.location);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.success-modal {
  &__body {
    padding: 12px;
  }

  &__msg {
    font-size: 1.25rem;
    font-weight: 500;
    color: #636d77;
  }
}
</style>
